/*
 * @Descripttion: 新增订单弹窗
 * @Author: renbh
 * @Date: 2023-07-03 14:19:47
 * @LastEditors: renbh
 * @LastEditTime: 2023-07-04 10:48:40
 */

import CustomModal from '../../../../components/ModalUser'
import { Col, Row, Spin } from 'antd'
import Search from '../../../../components/SearchFilter'
import useAddOrderModalHook, { Props } from './hooks'
import moment from 'moment'
import InfiniteScroll from 'react-infinite-scroll-component'
import TableAntd from '../../../../components/TableAntd'

const ModalListColumn = [
  {
    key: 'orderNo',
    dataIndex: 'orderNo',
    title: '客户订单号',
    width: 100,
    ellipsis: true,
  },
  {
    key: 'customer',
    dataIndex: 'customer',
    title: '客户名称',
    width: 100,
    ellipsis: true,
  },
  {
    key: 'platform',
    dataIndex: 'platform',
    title: '下单平台',
    width: 100,
    ellipsis: true,
  },
  {
    key: 'orderTime',
    dataIndex: 'orderTime',
    title: '下单时间',
    width: 100,
    render: (text: any) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
    ellipsis: true,
  },
  {
    key: 'orderPrice',
    dataIndex: 'orderPrice',
    title: '下单金额',
    width: 100,
    ellipsis: true,
  },
  {
    key: 'finalPrice',
    dataIndex: 'finalPrice',
    title: '最终结算金额',
    width: 100,
    ellipsis: true,
  },
]

const AddOrderModal = (props: Props) => {
  const { open, ...restProps } = props
  const {
    hooksState,
    handleSearchClick,
    onChangeCheck,
    modalSubmit,
    loadMoreData,
  } = useAddOrderModalHook(props)
  const { orderData, loading, pagination, checkedKeys } = hooksState

  return (
    <CustomModal
      width={770}
      bodyStyle={{ padding: 16 }}
      {...restProps}
      open={open}
      title="新增对账订单"
      okText="提交"
      modalSubmit={modalSubmit}
    >
      <Row gutter={[0, 8]}>
        <Col span={24}>
          <Search
            fieldsData={['orderNo', 'customer', 'platform']}
            onSearch={handleSearchClick}
            keyName="RECONCILABLEORDERS"
            ScreenKey="RECONCILABLEORDERS"
            hideScheme
          />
        </Col>
        <Col span={24}>
          <InfiniteScroll
            dataLength={orderData.length}
            next={loadMoreData}
            hasMore={orderData.length < pagination.totalCount}
            loader={<Spin spinning />}
            endMessage="已全部加载~"
            height={400}
          >
            <TableAntd
              dataSource={orderData}
              loading={loading}
              listColumn={ModalListColumn}
              scroll={{
                y: 'auto',
              }}
              onChangeCheck={onChangeCheck}
              defaultlist={checkedKeys}
              scrollStyle={{
                height: 'auto',
              }}
            />
          </InfiniteScroll>
        </Col>
      </Row>
    </CustomModal>
  )
}

export default AddOrderModal
/*
 * @Descripttion: 新增订单弹窗
 * @Author: renbh
 * @Date: 2023-07-03 14:19:47
 * @LastEditors: renbh
 * @LastEditTime: 2023-07-04 10:48:40
 */

import CustomModal from '../../../../components/ModalUser'
import { Col, Row, Spin } from 'antd'
import Search from '../../../../components/SearchFilter'
import useAddOrderModalHook, { Props } from './hooks'
import moment from 'moment'
import InfiniteScroll from 'react-infinite-scroll-component'
import TableAntd from '../../../../components/TableAntd'

const ModalListColumn = [
  {
    key: 'orderNo',
    dataIndex: 'orderNo',
    title: '客户订单号',
    width: 100,
    ellipsis: true,
  },
  {
    key: 'customer',
    dataIndex: 'customer',
    title: '客户名称',
    width: 100,
    ellipsis: true,
  },
  {
    key: 'platform',
    dataIndex: 'platform',
    title: '下单平台',
    width: 100,
    ellipsis: true,
  },
  {
    key: 'orderTime',
    dataIndex: 'orderTime',
    title: '下单时间',
    width: 100,
    render: (text: any) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
    ellipsis: true,
  },
  {
    key: 'orderPrice',
    dataIndex: 'orderPrice',
    title: '下单金额',
    width: 100,
    ellipsis: true,
  },
  {
    key: 'finalPrice',
    dataIndex: 'finalPrice',
    title: '最终结算金额',
    width: 100,
    ellipsis: true,
  },
]

const AddOrderModal = (props: Props) => {
  const { open, ...restProps } = props
  const {
    hooksState,
    handleSearchClick,
    onChangeCheck,
    modalSubmit,
    loadMoreData,
  } = useAddOrderModalHook(props)
  const { orderData, loading, pagination, checkedKeys } = hooksState

  return (
    <CustomModal
      width={770}
      bodyStyle={{ padding: 16 }}
      {...restProps}
      open={open}
      title="新增对账订单"
      okText="提交"
      modalSubmit={modalSubmit}
    >
      <Row gutter={[0, 8]}>
        <Col span={24}>
          <Search
            fieldsData={['orderNo', 'customer', 'platform']}
            onSearch={handleSearchClick}
            keyName="RECONCILABLEORDERS"
            ScreenKey="RECONCILABLEORDERS"
            hideScheme
          />
        </Col>
        <Col span={24}>
          <InfiniteScroll
            dataLength={orderData.length}
            next={loadMoreData}
            hasMore={orderData.length < pagination.totalCount}
            loader={<Spin spinning />}
            endMessage="已全部加载~"
            height={400}
          >
            <TableAntd
              dataSource={orderData}
              loading={loading}
              listColumn={ModalListColumn}
              scroll={{
                y: 'auto',
              }}
              onChangeCheck={onChangeCheck}
              defaultlist={checkedKeys}
              scrollStyle={{
                height: 'auto',
              }}
            />
          </InfiniteScroll>
        </Col>
      </Row>
    </CustomModal>
  )
}

export default AddOrderModal
